import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jiantou",
  "use": "icon-jiantou-usage",
  "viewBox": "0 0 35 27",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 35 27\" id=\"icon-jiantou\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-1-4h36v36H-1z\" /><path d=\"m0 16.88 8.552 8.551 1.575 1.576 1.576-1.576 22.73-22.28L31.283 0 10.127 20.506l-6.976-6.778z\" fill=\"#0078FF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol